const FINE   = window.matchMedia('(pointer:fine)').matches;
const REDUCE = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
const DESKTOP= FINE && !REDUCE;

/* 1 · STARFIELD */
(function(){
  const canvas=document.getElementById('starfield');
  if(!DESKTOP||!canvas){canvas&&canvas.remove();return;}
  const ctx=canvas.getContext('2d');let w,h,stars,dpr;
  function build(){
    dpr=Math.min(window.devicePixelRatio||1,2);
    w=canvas.width=innerWidth*dpr;h=canvas.height=innerHeight*dpr;
    canvas.style.width=innerWidth+'px';canvas.style.height=innerHeight+'px';
    stars=Array.from({length:Math.min(120,Math.floor(innerWidth/14))},()=>({x:Math.random()*w,y:Math.random()*h,z:Math.random()*.8+.2,r:Math.random()*1.2+.2}));
  }
  build();addEventListener('resize',build,{passive:true});
  let px=0,py=0,tx=0,ty=0;
  addEventListener('mousemove',e=>{tx=(e.clientX/innerWidth-.5);ty=(e.clientY/innerHeight-.5);},{passive:true});
  (function draw(){
    px+=(tx-px)*.03;py+=(ty-py)*.03;ctx.clearRect(0,0,w,h);
    for(const s of stars){
      s.y+=s.z*.09*dpr;if(s.y>h)s.y=0;
      const ox=px*50*s.z*dpr,oy=py*50*s.z*dpr;
      ctx.beginPath();ctx.arc(s.x+ox,s.y+oy,s.r*s.z*dpr,0,Math.PI*2);
      ctx.fillStyle=`rgba(170,195,250,${.08+s.z*.28})`;ctx.fill();
    }
    requestAnimationFrame(draw);
  })();
})();

/* 2 · REALISTIC EYE — cursor tracking + idle float + pupil follows mouse */
(function(){
  const layers=[...document.querySelectorAll('.eye-layer')];
  const eye3d=document.getElementById('eye3d');
  const pupil=document.getElementById('eyePupil');
  if(!eye3d)return;

  let mx=0,my=0,cx=0,cy=0,idle=0,sd=0;
  let lastMx=innerWidth/2, lastMy=innerHeight/2;
  let isMoving=false, moveTimer=null;

  addEventListener('mousemove',e=>{
    mx=(e.clientX/innerWidth-.5)*2;
    my=(e.clientY/innerHeight-.5)*2;
    lastMx=e.clientX; lastMy=e.clientY;
    isMoving=true;
    clearTimeout(moveTimer);
    moveTimer=setTimeout(()=>{isMoving=false;},1000); // after 1s idle → center
  },{passive:true});

  // On scroll: use scroll position as target for eye
  addEventListener('scroll',()=>{
    sd=Math.min(scrollY/innerHeight,1);
    // When scrolling, eye looks slightly downward
    my=sd*.6;
  },{passive:true});

  (function loop(){
    cx+=(mx-cx)*.04;cy+=(my-cy)*.04;idle+=.005;

    // 3D tilt of whole eye
    if(DESKTOP){
      eye3d.style.transform=`rotateX(${-cy*4}deg) rotateY(${cx*6}deg) translateZ(${-sd*60}px)`;
    }

    // Layer parallax
    layers.forEach(l=>{
      if(l.classList.contains('eye-iris-real'))return;
      if(l.classList.contains('eyelid-top'))return;
      if(l.classList.contains('eyelid-bottom'))return;
      const d=+(l.dataset.depth||0);
      const fx=Math.sin(idle)*d*.18;
      const fy=Math.cos(idle*.85)*d*.18;
      l.style.transform=`translate(calc(-50% + ${cx*d+fx}px),calc(-50% + ${cy*d+fy}px))`;
    });

    // Pupil tracks cursor (limited movement radius)
    if(pupil){
      const maxMove=22; // px
      const px2=cx*maxMove;
      const py2=cy*maxMove;
      pupil.style.transform=`translate(calc(-50% + ${px2}px),calc(-50% + ${py2}px))`;
    }

    requestAnimationFrame(loop);
  })();
})();

/* 3 · CAROUSEL DRAG + ARROWS */
(function(){
  const track=document.getElementById('carouselTrack');
  if(!track)return;
  let isDown=false,startX,scrollLeft;
  track.addEventListener('mousedown',e=>{isDown=true;startX=e.pageX-track.offsetLeft;scrollLeft=track.scrollLeft;track.style.cursor='grabbing';});
  track.addEventListener('mouseleave',()=>{isDown=false;track.style.cursor='grab';});
  track.addEventListener('mouseup',()=>{isDown=false;track.style.cursor='grab';});
  track.addEventListener('mousemove',e=>{if(!isDown)return;e.preventDefault();const x=e.pageX-track.offsetLeft;track.scrollLeft=scrollLeft-(x-startX)*1.5;});
  document.getElementById('prevBtn')?.addEventListener('click',()=>track.scrollBy({left:-320,behavior:'smooth'}));
  document.getElementById('nextBtn')?.addEventListener('click',()=>track.scrollBy({left:320,behavior:'smooth'}));
  // Keyboard support
  addEventListener('keydown',e=>{if(e.key==='ArrowLeft')track.scrollBy({left:-200,behavior:'smooth'});if(e.key==='ArrowRight')track.scrollBy({left:200,behavior:'smooth'});});
})();

/* 4 · PRODUCT CARD GLASS SHEEN */
if(DESKTOP){
  document.querySelectorAll('.product-card').forEach(card=>{
    card.addEventListener('mousemove',e=>{
      const r=card.getBoundingClientRect();
      card.style.setProperty('--mx',((e.clientX-r.left)/r.width*100)+'%');
      card.style.setProperty('--my',((e.clientY-r.top)/r.height*100)+'%');
    },{passive:true});
  });
}

/* 5 · HEADER SCROLL STATE */
(function(){
  const h=document.getElementById('header');
  const f=()=>h.classList.toggle('scrolled',scrollY>40);
  addEventListener('scroll',f,{passive:true});f();
})();

/* 6 · SCROLL REVEAL */
(function(){
  const els=[...document.querySelectorAll('.reveal')];
  if(!('IntersectionObserver'in window)){els.forEach(e=>e.classList.add('in'));return;}
  const io=new IntersectionObserver((en)=>{
    en.forEach((x,i)=>{
      if(x.isIntersecting){
        x.target.style.transitionDelay=(i%4*100)+'ms';
        x.target.classList.add('in');
        io.unobserve(x.target);
      }
    });
  },{threshold:.12});
  els.forEach(el=>io.observe(el));
})();

/* 7 · NEWSLETTER — handled natively by Shopify customer form */

/* 8 · SMOOTH NAV */
document.querySelectorAll('a[href^="#"]').forEach(a=>{
  a.addEventListener('click',e=>{
    const id=a.getAttribute('href');
    if(id.length>1){const t=document.querySelector(id);if(t){e.preventDefault();t.scrollIntoView({behavior:'smooth'});}}
  });
});
